import { UpdateClipType } from '../clipUpdateDataUtils/types';
import { getAllCompositeSegments } from './compositeUtils';
import { CLIP_UPDATE_TYPE } from './constants';
import { UpdateClipAction as UpdateClipActionUtils } from './types';
import { Clip } from '@/domains/asset';

export const injectSegmentIdInUpdateClipPayload = (updateClipPayload: UpdateClipType, clip: Clip) => {
  const compositeSegments = getAllCompositeSegments(clip);

  if (compositeSegments.length === 0) {
    throw new Error('No composite segments found');
  }

  if ((updateClipPayload as any).compositeId) {
    return updateClipPayload as UpdateClipActionUtils;
  }

  const compositeSegment = compositeSegments[0];

  switch (updateClipPayload.actionType) {
    case CLIP_UPDATE_TYPE.UPDATE_COMPOSITE_SEGMENT_DELETE:
    case CLIP_UPDATE_TYPE.REMOVE_COMPOSITE_SEGMENT_DELETE:
    case CLIP_UPDATE_TYPE.UPDATE_SCENE_CROP_POSITION:
    case CLIP_UPDATE_TYPE.ADD_COMPOSITE_SCENE:
    case CLIP_UPDATE_TYPE.ADD_COMPOSITE_SCENE_RANGE:
    case CLIP_UPDATE_TYPE.REMOVE_COMPOSITE_SCENE:
    case CLIP_UPDATE_TYPE.UPDATE_COMPOSITE_SCENE:
    case CLIP_UPDATE_TYPE.TOGGLE_VIDEO_VISIBILITY_FROM_SCENE:
    case CLIP_UPDATE_TYPE.ADD_COMPOSITE_SEGMENT_DELETE_WORDS:
    case CLIP_UPDATE_TYPE.ADD_COMPOSITE_SEGMENT_EFFECT:
    case CLIP_UPDATE_TYPE.UPDATE_SEGMENT_TRACK:
    case CLIP_UPDATE_TYPE.BULK_ADD_COMPOSITE_SEGMENT_DELETES:
    case CLIP_UPDATE_TYPE.BULK_PUT_COMPOSITE_SEGMENT_DELETE:
    case CLIP_UPDATE_TYPE.HIDE_WORD:
    case CLIP_UPDATE_TYPE.SHOW_WORD:
    case CLIP_UPDATE_TYPE.EDIT_WORD:
    case CLIP_UPDATE_TYPE.CORRECT_ALL:
      if (compositeSegments.length !== 1) {
        throw new Error(
          'Multiple composite segments detected (splits). Please provide compositeId to specify which segment to update.'
        );
      }
      return {
        ...updateClipPayload,
        compositeId: (updateClipPayload as any).compositeId ?? compositeSegment.id
      } as UpdateClipActionUtils;
    default:
      return updateClipPayload as UpdateClipActionUtils;
  }
};
